const occupations = [
  "Accounting",
  "Admin & Clerical",
  "Administrative Assistant",
  "Automotive",
  "Banking",
  "Biotech",
  "Broadcast",
  "Business Development",
  "Construction",
  "Consultant",
  "Counselling",
  "Customer Service",
  "Dentistry",
  "Design",
  "Distribution",
  "Doctor",
  "Education",
  "Engineering",
  "Entrepreneur",
  "Facilities",
  "Finance",
  "Firefighter",
  "Food Service",
  "Franchise",
  "General Business",
  "General Labor",
  "Government",
  "Grocery",
  "Health Care",
  "Hospitality",
  "Hotel",
  "Human Resources",
  "Information Technology",
  "Installation - Maintenance",
  "Insurance",
  "Inventory",
  "Journalism",
  "Journalism",
  "Law Enforcement",
  "Legal",
  "Legal Admin",
  "Management",
  "Manufacturing",
  "Marketing",
  "Media",
  "Newspaper",
  "Nonprofit",
  "Nurse",
  "Pharmaceutical",
  "Planning",
  "Procurement",
  "Professional Services",
  "Purchasing",
  "QA - Quality Control",
  "Real Estate",
  "Repair",
  "Research",
  "Restaurant",
  "Retail",
  "Sales",
  "Science",
  "Self-Employed",
  "Shipping",
  "Skilled Labor",
  "Social Services",
  "Software",
  "Strategy",
  "Student",
  "Supply Chain",
  "Teaching",
  "Telecommunications",
  "Trades",
  "Training",
  "Transportation",
  "Unemployed",
  "Warehouse",
  "Web Design",
  "Other",
];
const sources = [
  "Employment",
  "Trading",
  "Inheritance",
  "Active Entrepreneur",
  "Wealth Generated (Savings)",
  "Former Entrepreneur",
  "Other",
];
const amounts = [
  "$0-$500",
  "$500-$2,000",
  "$2,000-$5,000",
  "$5,000-$10,000",
  "$10,000-$50,000",
  "$50,000+",
];
const skillsLevels = ["Beginner", "Intermediate", "Expert"];
const purposes = [
  "Trading",
  "Investing",
  "Store crypto assets",
  "Sending and receiving of crypto",
  "Other",
];

module.exports = {
  occupations,
  sources,
  amounts,
  skillsLevels,
  purposes,
};
